import Button from "components/BaseWidgets/button";
import "./style.scss";
import Modal from "components/BaseWidgets/modal";

function ActionModal({
  open,
  setOpen,
  title,
  description,
  width = 464,
  icon,
  footer,
  children,
  centerMode = true,
  centered,
  className,
  onCancel,
}) {
  const modalFooter = footer ? (
    <div className="flex items-center gap-3 w-full">
      {footer.left && (
        <Button
          height={44}
          wFull
          variant="secondary"
          onClick={footer.left.action}
        >
          {footer.left.label}
        </Button>
      )}
      {footer.right && (
        <Button
          height={44}
          wFull
          variant="primary"
          onClick={footer.right.action}
          isLoading={footer.right.isLoading}
        >
          {footer.right.label}
        </Button>
      )}
    </div>
  ) : null;

  return (
    <Modal
      isOpen={open}
      onCancel={() => {
        if (onCancel) {
          onCancel();
        }
        setOpen(false);
      }}
      closable
      footer={footer && modalFooter}
      width={width}
      wrapClassName={`action-modal ${centerMode ? "center-modal" : ""} ${className ? className : ""}`}
      centered={centered}
    >
      {icon && <span className="icon">{icon}</span>}
      {title && <span className="title">{title}</span>}
      {description && <p className="description">{description}</p>}
      {children && children}
    </Modal>
  );
}

export default ActionModal;
